import { Grid, styled } from "@mui/material";

import Select from "components/Select";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function WalletInput() {
  const [searchParams, setSearchParams] = useSearchParams();

  const walletList = useSelector(
    (state) => state.wallet?.portfolioBasketMenu?.data
  );
  const walletListFiltered = walletList?.filter(
    (wallet) => wallet.isHaveBasket === true
  );

  const basketId =
    +searchParams.get("basketId") || walletListFiltered?.[0]?.basketId || 0;

  const handleChange = (e) => {
    const val = e?.target?.value;
    const allSearchParams = Object.fromEntries([...searchParams]);

    const portfolioId = walletListFiltered.find(
      (item) => item.basketId === +val
    )?.portfolioId;

    setSearchParams({
      ...allSearchParams,
      basketId: val,
      portfolioId,
    });
  };

  return (
    <Grid container mb={1}>
      <Grid item xs={12}>
        <SelectStyle
          items={walletListFiltered}
          itemValue="basketId"
          itemText="basket"
          justifyContent="center"
          value={basketId}
          onChange={handleChange}
        />
      </Grid>
    </Grid>
  );
}

const SelectStyle = styled(Select)(({ theme }) => ({
  textAlign: "center",
  ".MuiSelect-select": {
    padding: theme.spacing(0.5, 2.5),
    fontSize: "12px",
  },
}));

export default WalletInput;
